import React, { PureComponent } from 'react';

import NotFound from 'widgets/NotFound/NotFound';

export default class NotAvailablePage extends PureComponent {
  render() {
    return (
      <div>
        <NotFound>
          <h1>Sorry, we can&apos;t find that page</h1>
          <p>Please try searching, or <a href="/">browse our range</a>.</p>
        </NotFound>
      </div>
    );
  }
}
